import { render, staticRenderFns } from "./ChoosePermissionMulti.vue?vue&type=template&id=775a3f7e&scoped=true"
import script from "./ChoosePermissionMulti.vue?vue&type=script&lang=js"
export * from "./ChoosePermissionMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a3f7e",
  null
  
)

export default component.exports